import { off, onValue, ref, set } from 'firebase/database';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useCallback, useContext, useEffect, useState } from 'react';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { gameScoringTypes } from '../cnr/reducers/SportsSeasonReducer';
import { realTimeScoring } from '../dbActions/realtimeScoring';
import { matchCalcs } from '../helpers/match';
import _ from 'lodash';

export function useRealtimeResults({ currentSeason_info }) {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { pathViews } = paps_state
  const { app_ts, mainRt } = app_state
  const { latestSeason } = currentSeason_info ?? {}

  const [realtimeResults, setRealtimeResults] = useState({});

  useEffect(() => {
    if (!latestSeason) return
    const path_realtime = `clients/${pathViews.clients}/events/${pathViews.events}/${pathViews.sports}/realtimeResults/${latestSeason}/`
    const submissionsRef = ref(app_ts.realtime, path_realtime);
    // Listen for live changes
    const unsubscribe = onValue(submissionsRef, (snapshot) => {
      setRealtimeResults({ realtimeResults: snapshot.val() || {} });
    });

    // Cleanup listener on unmount
    return () => off(submissionsRef);
  }, [latestSeason]);

  return { realtimeResults };
}

export function useRealtimeMatchResults({ currentSeason_info }) {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { pathViews } = paps_state
  const { app_ts, mainRt } = app_state
  const { latestSeason } = currentSeason_info ?? {}

  const [realtimeResults, setRealtimeResults] = useState({});

  useEffect(() => {
    if (!latestSeason) return
    const path_realtime = `clients/${pathViews.clients}/events/${pathViews.events}/${pathViews.sports}/realtimeResults/${latestSeason}/`
    const submissionsRef = ref(app_ts.realtime, path_realtime);
    // Listen for live changes
    const unsubscribe = onValue(submissionsRef, (snapshot) => {
      setRealtimeResults({ realtimeResults: snapshot.val() || {} });
    });

    // Cleanup listener on unmount
    return () => off(submissionsRef);
  }, [latestSeason]);

  return { realtimeResults };
}

export function useRealtimeUpdates() {

  const appUserAccess = useAppUserAccess()
  const appUserInfo = appUserAccess ? { displayName: appUserAccess.displayName, uid: appUserAccess.uid } : {}
  const { displayName, uid } = appUserInfo ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { pathViews } = paps_state
  const { app_ts, mainRt } = app_state

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, sportPermissions, sportDataSettings } = sportsSeason_state ?? {}
  const { latestSeason } = currentSeason_info ?? {}


  const updateRtMatchScore = useCallback(async ({ match_rt, match_true, rtType, add }) => {
    const path_realtime = `clients/${pathViews.clients}/events/${pathViews.events}/${pathViews.sports}/realtimeResults/${latestSeason}/${uid}`
    handleRealTimeChange({ match_rt, match_true, rtType, add })
    matchCalcs.calcVballMatch(match_rt, gameScoringTypes.matchPoints)
    realTimeScoring.calcMatchAndUpdateRtDb(
      app_ts.realtime,
      sportPermissions,
      sportDataSettings,
      match_rt,
      match_true,
      pathViews,
      appUserInfo,
      latestSeason,
      null,
      path_realtime
    )
  }, [])

  const updateRtMatch = useCallback(async ({ match_rt, match_true }) => {
    const path_realtime = `clients/${pathViews.clients}/events/${pathViews.events}/${pathViews.sports}/realtimeResults/${latestSeason}/${match_true?._itemKey}/${uid}`
    matchCalcs.calcVballMatch(match_rt, gameScoringTypes.matchPoints)
    const { results, setNumber } = match_rt ?? {}
    const { scores, score } = results ?? {}
    const _results = {
      score,
      scores: {}
    }
    _.forEach(scores, (score, setNumber) => {
      _results.scores[`set${setNumber}`] = score
    })
    const updateData = { displayName, setNumber, results: _results };
    await set(ref(app_ts.realtime, path_realtime), updateData);
  }, [])

  return { updateRtMatchScore, updateRtMatch };
}

const handleRealTimeChange = ({ match_rt, rtType, add, selectedStat }) => {

  let { _results } = match_rt ?? {}

  const { setNumber } = _results ?? {}
  let _setNumber = setNumber ? setNumber : 1

  switch (rtType) {
    case 'away':
    case 'home':
      const sn = setNumber
      if (!_results.scores) { _results.scores = {} }
      if (!_results.scores[sn]) {
        _results.scores[sn] = {
          away: 0,
          home: 0
        }
      }
      let teamScore = _results.scores[sn][rtType]
      if (add) {
        teamScore++
      } else {
        teamScore--
      }
      if (teamScore < 0) { teamScore = 0 }

      _results.scores[setNumber][rtType] = teamScore

      // const _rtTracker = addPoint(rtType, setNumber, match_rt_tracker, selectedStat)
      // handleRtChange_score(teamScore, rtType, _rtTracker)
      break;

    case 'set':
      if (add) {
        _setNumber++
      } else {
        _setNumber--
      }
      if (_setNumber < 1) { teamScore = 1 }
      if (_setNumber > 5) { teamScore = 5 }
      // handleRtChange_set(_setNumber)
      break;

    default:
      break;
  }
}